import React from 'react';
import { RFC } from 'state/StateTypes';
import styled from 'styled-components';
import { AssetTypes } from 'state/assets/AssetTypes';
import FlexWrapper from './FlexWrapper';
import ModalButton from './ModalButton';

interface Props {
   onConfirm: () => void;
   onCancel: () => void;
   assetType: AssetTypes;
   assetName: string;
}

const DeleteAssetConfirmationModalContent: RFC<Props> = ({ onConfirm, onCancel, assetName, assetType }) => (
   <ModalContent>
      Are you sure you want to delete <Highlight>{assetName}</Highlight> from the list of {assetType}s?
      <FlexWrapper justifyContent="center" margin="3em 0 0" flexWrap="wrap">
         <ModalButton action="cancel" onClick={onCancel}>
            Cancel
         </ModalButton>
         <ModalButton action="confirm" onClick={onConfirm}>
            Yes
         </ModalButton>
      </FlexWrapper>
   </ModalContent>
);

export default DeleteAssetConfirmationModalContent;

const ModalContent = styled.div`
   margin: 3em auto 1em auto;
   padding: 10px;
   text-align: center;
   color: black;
   font-size: 1.3em;
   line-height: 1.6;
   min-width: 375px;
   @media only screen and (max-width: 415px) {
      font-size: 1.2em;
      padding: 9px;
   }
`;

const Highlight = styled.span`
   font-weight: bold;
   color: ${({ theme }) => theme.secondaryBlueDark};
`;
